import { t } from "i18next"
import {
  BASE_NO_SPECIALTY,
  BASE_NO_TIME_TO_TREAT,
  baseSchema,
} from "@/modules/patients/detail/progress-note/point-of-care/schema/base-schema"
import { Gatekeeper, PointOfCareType } from "@/types/__generated__/union-types"

const NO_SPECIALTY: PointOfCareType[] = [...BASE_NO_SPECIALTY, "EXTERNAL_ASSISTANCE"]

const HAS_CARE_PROVIDER: PointOfCareType[] = [
  "GENERAL_PRACTITIONER",
  "SPECIALIST",
  "HOSPITAL_ELECTIVE",
  "HOSPITAL_EMERGENCY_ROOM",
  "MEDICAL_EMERGENCY_OR_PERMANENCE",
]

const NO_TIME_TO_TREAT: PointOfCareType[] = [...BASE_NO_TIME_TO_TREAT, "EXTERNAL_ASSISTANCE"]

export const REQUIRED_CARE_PROVIDER: (Gatekeeper | null)[] = ["MEDGATE_ONLY", "MEDGATE_AND_OTHERS"] as const

export const ChPointOfCareSchema = (gatekeeper: Gatekeeper | null) => {
  return baseSchema.superRefine((data, ctx) => {
    const activePointOfCare = data.actualPointOfCare ?? data.medicalPointOfCare
    if (activePointOfCare) {
      if (
        REQUIRED_CARE_PROVIDER.includes(gatekeeper) &&
        HAS_CARE_PROVIDER.includes(activePointOfCare) &&
        !data.careProviderId &&
        !data.betterDocSuggestionStatus
      ) {
        // Adds error that makes careProvider required
        ctx.addIssue({
          code: "custom",
          message: t("common.fieldErrorList.requiredField"),
          path: ["careProviderId"],
        })
      }
      if (!NO_SPECIALTY.includes(activePointOfCare) && !data.specialtyId) {
        // Adds error that makes specialty required
        ctx.addIssue({
          code: "custom",
          message: t("common.fieldErrorList.requiredField"),
          path: ["specialtyId"],
        })
      }
      if (!NO_TIME_TO_TREAT.includes(activePointOfCare) && !data.timeToTreatType) {
        // Adds error that makes timeToTreatType required
        ctx.addIssue({
          code: "custom",
          message: t("common.fieldErrorList.requiredField"),
          path: ["timeToTreatType"],
        })
      }
    }
    if (data.medicalPointOfCare && data.actualPointOfCare && !data.reasonForChoosingType) {
      // Adds error that makes reasonForChoosingType required, if actualPointOfCare has value
      ctx.addIssue({
        code: "custom",
        message: t("common.fieldErrorList.requiredField"),
        path: ["reasonForChoosingType"],
      })
    }
  })
}
